import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { getCategory } from './queries';
import { NAV_HEIGHT, PAGE_TITLE } from '../../../config/constants';
import { ERROR_MESSAGE, SIZE_GUIDE_QUESTION_ID, SUGGEST } from './constants';
import css from './Category.module.scss';
import PlusToMinus from '../../../components/icons/PlusToMinus';
import SizeGuide from './SizeGuide';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Question = function Question(_ref) {
  var description = _ref.description,
      id = _ref.id,
      index = _ref.index,
      isSearchResult = _ref.isSearchResult,
      on = _ref.on,
      setIndex = _ref.setIndex,
      slug = _ref.slug,
      title = _ref.title;
  var attrs = on ? {} : {
    hidden: 'hidden',
    'aria-expanded': 'false'
  };
  var headerId = "header-".concat(slug);
  var panelId = "panel-".concat(slug);

  var onClick = function onClick(event) {
    if (event.metaKey) {
      return;
    }

    event.preventDefault();
    var newIndex = on ? -1 : index;
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search;
    var _window = window,
        history = _window.history;
    setIndex(newIndex);

    if (isSearchResult) {
      return;
    }

    history.pushState(null, null, on ? pathname + search : "#".concat(slug));
  };

  return /*#__PURE__*/_jsx("div", {
    className: css.question,
    id: slug,
    children: id === SIZE_GUIDE_QUESTION_ID ? /*#__PURE__*/_jsx("div", {
      "aria-labelledby": headerId,
      className: cc([css.content, css.padded]),
      id: panelId,
      children: /*#__PURE__*/_jsx(SizeGuide, {})
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("a", {
        "aria-controls": panelId,
        "aria-expanded": on,
        id: headerId,
        className: cc([css.button, _defineProperty({}, css.on, on)]),
        onClick: onClick,
        href: "#".concat(slug),
        children: [title, /*#__PURE__*/_jsx(PlusToMinus, {
          open: on
        })]
      }), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, attrs), {}, {
        "aria-labelledby": headerId,
        className: css.content,
        dangerouslySetInnerHTML: {
          __html: description
        },
        id: panelId
      }))]
    })
  });
};

Question.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  index: PropTypes.number,
  on: PropTypes.bool,
  setIndex: PropTypes.func,
  isSearchResult: PropTypes.bool,
  slug: PropTypes.string,
  title: PropTypes.string
};
export var Category = function Category(_ref3) {
  var articles = _ref3.articles,
      initialIndex = _ref3.initialIndex,
      _ref3$searchResults = _ref3.searchResults,
      searchResults = _ref3$searchResults === void 0 ? false : _ref3$searchResults;

  var _useState = useState(initialIndex),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var scrollToLink = function scrollToLink(id) {
    var question = document.querySelector("".concat(id));

    if (!question) {
      return;
    }

    var top = question.offsetTop - NAV_HEIGHT;
    window.scrollTo({
      top: top
    });
  }; // Hook to handle scrolling to a question based on the location hash


  useEffect(function () {
    var hash = window.location.hash;

    if (!hash || !document.querySelector(hash)) {
      return;
    }

    setTimeout(function () {
      scrollToLink(hash);
    }, 100);
  }, []);
  useEffect(function () {
    var onSuggest = function onSuggest(event) {
      var hash = event.detail;
      setTimeout(function () {
        scrollToLink(hash);
        var slug = hash.replace('#', '');
        var newIndex = articles.findIndex(function (cat) {
          return cat.slug === slug;
        });
        setIndex(newIndex);
      }, 100);
    };

    window.addEventListener(SUGGEST, onSuggest);
    return function () {
      window.removeEventListener(SUGGEST, onSuggest);
    };
  }, [articles]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: articles.map(function (_ref4, idx) {
      var id = _ref4.id,
          title = _ref4.title,
          description = _ref4.description,
          slug = _ref4.slug;
      return /*#__PURE__*/_jsx(Question, {
        description: description,
        index: idx,
        id: id,
        on: idx === index,
        isSearchResult: searchResults,
        setIndex: setIndex,
        slug: slug,
        title: title
      }, id);
    })
  });
};
Category.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string
  })),
  initialIndex: PropTypes.number,
  searchResults: PropTypes.bool
};

var CategoryLoader = function CategoryLoader(_ref5) {
  var id = _ref5.id,
      title = _ref5.title;
  var hash = window.location.hash;

  var _useQuery = useQuery({
    query: getCategory,
    variables: {
      id: id
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error; // Change the page title


  useEffect(function () {
    document.title = "".concat(title).concat(PAGE_TITLE);
  }, [title]);

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: ERROR_MESSAGE
    });
  }

  var index = 0;

  if (!fetching && data && hash) {
    var slug = hash.replace('#', '');
    index = data.faqsCategory.articles.findIndex(function (cat) {
      return cat.slug === slug;
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), fetching && /*#__PURE__*/_jsx("div", {
      "aria-busy": "true",
      children: new Array(4).fill().map(function (_, idx) {
        return /*#__PURE__*/_jsxs("div", {
          className: css.question,
          children: [/*#__PURE__*/_jsx("div", {
            className: cc([css.button, _defineProperty({}, css.on, idx === 0)]),
            children: /*#__PURE__*/_jsx("div", {
              className: css.loading,
              children: "\xA0"
            })
          }), idx === 0 && /*#__PURE__*/_jsx("div", {
            className: css.content,
            children: /*#__PURE__*/_jsx("div", {
              className: cc([css.loading, css.content]),
              children: "\xA0"
            })
          })]
        }, idx);
      })
    }), !fetching && data && /*#__PURE__*/_jsx(Category, _objectSpread(_objectSpread({}, data.faqsCategory), {}, {
      initialIndex: index > -1 ? index : 0
    }))]
  });
};

CategoryLoader.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string
};
export default CategoryLoader;